import SignupTemplatePage from "@features/signup/Pages/SignupTemplatePage";
import {
  SignupFormFieldName,
  SignupSchemaField,
  SignupStep,
} from "@features/signup/constants";
import { useEffect } from "react";
import { TextField } from "../../../components/ui/index";
import { useSignupForm } from "../hooks/useSignupForm";
import useSubmitSignupData from "../hooks/useSubmitSignupData";

const CURRENT_STEP = SignupStep.Referrer;

const ReferrerPage = () => {
  const { completeSignup, error, isError, isLoading } = useSubmitSignupData();
  const {
    handleSubmit,
    control,
    formState: { isSubmitSuccessful },
  } = useSignupForm({
    schemaField: SignupSchemaField.Referrer,
    defaultValues: {
      [SignupFormFieldName.Referrer]: "",
    },
  });

  useEffect(() => {
    if (isSubmitSuccessful) {
      completeSignup();
    }
  }, [completeSignup, isSubmitSuccessful]);

  return (
    <SignupTemplatePage
      title="Last thing, how did you hear about us?"
      currentStep={CURRENT_STEP}
      onNextButtonClick={handleSubmit}
      errorMessage={
        isError
          ? (error as Error)?.message ||
            "Something went wrong. Could not complete sign up."
          : null
      }
      isSubmitting={isLoading}
    >
      <TextField
        name={SignupFormFieldName.Referrer}
        control={control}
        label="Input your answer (optional)"
        className="w-full"
      />
    </SignupTemplatePage>
  );
};

export default ReferrerPage;
